import React from 'react';

const Footer = (props) => {
  // style={{ display: 'none' }}
	return (
    <div>
      {/* <footer className="main">
        <a href="https://blatout.com/br/" target="_blank" rel="noopener noreferrer">
          Powered by Blat out
        </a>
      </footer> */}
    </div>
  )
};

export default Footer;